import StaffManagementConst from "./staff-management-const";
import StaffManagementFields from "./fields";
import StaffManagementFilters from "./filters";
import StaffManagementHelpers from "./helpers";
import StaffManagementHooks from "./hooks";
import StaffManagementForms from "./forms";

import "./staff-management.scss";


const StaffManagement = {
    Const: StaffManagementConst,
    Fields: StaffManagementFields,
    Filters: StaffManagementFilters,
    Helpers: StaffManagementHelpers,
    Hooks: StaffManagementHooks,
    Forms: StaffManagementForms,
};

export default StaffManagement;
